<template>
  <v-container grid-list-xl>
    <v-layout column justify-space-around>
      <v-flex>
        {{ adminText('workflowsAll.my_referrals_2b42b2f', 'My referrals') }}
      </v-flex>
      <v-flex>
        <referrals-table :items="workflowUi(referrals)" @delete="activeReferral = $event; showDeleteDialog=true" />
      </v-flex>
      <v-flex>
        <v-form v-model="isFormValid">
          <referral-form
            ref="form"
            :initial-values="{}"
          />
          <main-button
            :disabled="!isFormValid"
            :text="adminText('workflowsAll.create_6e157c5', 'Create')"
            depressed
            @click="submitForm($refs['form'].form);"
          />
        </v-form>
      </v-flex>
    </v-layout>
    <delete-dialog
      :on-delete="() => deleteReferral(activeReferral.id)"
      :on-cancel="()=> activeReferral = null"
      :show.sync="showDeleteDialog"
      :title="adminText('workflowsAll.delete_referral_07956b5', 'Delete referral')"
      :content="adminText('workflowsAll.are_you_sure_you_want_to_delete_selected_refe_6b8f522', 'Are you sure you want to delete selected referral? This operation cannot be undone.')"
    />
  </v-container>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import ReferralsTable from './referrals-table'
import ReferralForm from './referral-form'
import DeleteDialog from './../shared/dialogs/delete-dialog'
import MainButton from './../shared/main-button'
import { GET_EVENT_REFERRALS } from '../../graphql/referal.graphql'
import { createReferral, deleteReferralMutation } from '../../http'

export default {
  mixins: [WorkflowDisplay],
  name: 'referrals',
  components: {
    ReferralsTable,
    ReferralForm,
    DeleteDialog,
    MainButton,
  },
  props: {
    eventId: String,
  },
  data() {
    return {
      showDeleteDialog: false,
      activeReferral: null,
      isFormValid: false,
      referrals: [],
    }
  },
  methods: {
    async deleteReferral(id) {
      await deleteReferralMutation({
        id,
        eventId: this.eventId,
        refetchQueries: ['Referrals'],
      })
    },
    async submitForm(form) {
      const { name } = form
      await createReferral({
        eventId: this.eventId,
        name,
        refetchQueries: ['Referrals'],
      })
    },
  },
  apollo: {
    referrals: {
      query: GET_EVENT_REFERRALS,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      manual: true,
      result({ data, loading, errors }) {
        if (!loading && !errors) {
          this.referrals = data.referrals
        }
      },
    },
  },
}
</script>

<style>
</style>
